function TextAnimation(el) {
	var texts = $('.js-text-animation');
	$(texts).each(function(){
		$('.text-animation__message').append('<span class="text-animation__message-text">' + $(this).text() + '</span>');
		$(this).remove();
	});
	var firstText = $('.text-animation__message-text--first').text();
	setTimeout(function(){
		$('.text-animation__message-text--first').css('opacity', '0');
	}, 1500);
	setTimeout(function(){
		$('.text-animation__message-text--first').remove();
	}, 2000);
	$('.text-animation__message').append('<span class="text-animation__message-text">' + firstText + '</span>');
}

module.exports = TextAnimation;
